export default __webpack_public_path__ + "static/media/IDP-sante-logo.a7b1073d.svg";